import React, {FC} from "react"
import {StatementItem, TransactionType} from "@irati/types"
import BulkRewardTransfer from "./BulkRewardTransfer"
import RewardPointsRewarded from "./RewardPointsRewarded"

interface Props {
  statementItem: StatementItem,
  className?: string
}

const Reward: FC<Props> = ({statementItem, className}) => {
  if(statementItem.transactionType === TransactionType.BulkReward) {
    return <BulkRewardTransfer className={className} statementItem={statementItem} />
  }

  return <RewardPointsRewarded className={className} statementItem={statementItem} />
}

export default Reward
